import React from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

const whitelistedParams = [
  'unitNumber',
  'streetNumber',
];

const getPageUrl = (pathname, pageParam, page, query = null) => {
  let pageUrl = null;

  if (pathname.match(/\/agency\/.*\/\d+\/for-(sale|rent)/igm)) {
    pathname = pathname.split('/');
    pathname.pop();
    pathname = pathname.join('/');
  }
  let baseUrl = `https://www.onthehouse.com.au${pathname}`;

  const hasQuery = !!query;
  if (hasQuery) {
    pageUrl = page === 1 ? `${baseUrl}?${query}` : pageUrl;
    pageUrl = page > 1 ? `${baseUrl}?${query}&${pageParam}=${page}` : pageUrl;
  } else {
    pageUrl = page === 1 ? `${baseUrl}` : pageUrl;
    pageUrl = page > 1 ? `${baseUrl}?${pageParam}=${page}` : pageUrl;
  }

  return pageUrl;
};

const PagedSEO = props => {
  const {
    location: {pathname, search: queryString},
    lastPage,
    pageParam,
  } = props;

  const pageParamRegex = new RegExp(pageParam + '=([0-9]+)', 'i');
  const getPage = queryString.match(pageParamRegex);
  const currentPage = !!getPage ? parseInt(getPage[1]) : 1;

  const query = queryString.replace('?', '').split('&').filter((qs) =>  whitelistedParams.includes(qs.split('=')[0])).sort().join('&');

  const prevPage = currentPage - 1;
  const prevPageUrl = getPageUrl(pathname, pageParam, prevPage, query);

  const nextPage = currentPage + 1;
  const nextPageUrl = getPageUrl(pathname, pageParam, nextPage, query);

  const canonicalUrl = getPageUrl(pathname, pageParam, 1, query);

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />

      { prevPage >= 1 && prevPageUrl &&
        <link rel="prev" href={prevPageUrl} /> }

      { nextPage <= lastPage && nextPageUrl &&
        <link rel="next" href={nextPageUrl} /> }
    </Helmet>
  );
};

PagedSEO.defaultProps = {
  pageParam: 'page'
};

PagedSEO.propTypes = {
  lastPage: PropTypes.number.isRequired,
  location: PropTypes.object.isRequired,
  pageParam: PropTypes.string,
};

export default withRouter(PagedSEO);
